var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49609 18.6699C14.2531 18.6699 18.1094 14.6405 18.1094 9.66992C18.1094 4.69936 14.2531 0.669922 9.49609 0.669922C4.73911 0.669922 0.882812 4.69936 0.882812 9.66992C0.882812 14.6405 4.73911 18.6699 9.49609 18.6699Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50195 17.7207C14.2104 17.7207 18.0273 13.9038 18.0273 9.19531C18.0273 4.48687 14.2104 0.669922 9.50195 0.669922C4.79351 0.669922 0.976562 4.48687 0.976562 9.19531C0.976562 13.9038 4.79351 17.7207 9.50195 17.7207Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8883 1.37109L1.66641 12.5895C1.29023 11.7281 1.05469 10.793 0.984375 9.81211L10.1074 0.685547C11.0883 0.759375 12.0234 0.994922 12.8883 1.37109ZM16.9137 5.00625L5.30156 16.6184C4.57734 16.2105 3.92344 15.7008 3.35039 15.1066L15.4055 3.05508C15.9961 3.62461 16.5059 4.28203 16.9137 5.00625ZM15.0574 2.73516L3.03398 14.7586C2.84766 14.5406 2.66836 14.3121 2.50313 14.0766L14.3754 2.2043C14.6109 2.36953 14.8395 2.54883 15.0574 2.73516ZM17.7434 7.06289L7.3582 17.448C7.04531 17.3672 6.73945 17.2687 6.44063 17.1562L17.4516 6.14531C17.5641 6.44414 17.6625 6.75 17.7434 7.06289Z",
    fill: "white",
    fillOpacity: 0.313726
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0195 9.19141C18.0195 9.25117 18.0195 9.30742 18.016 9.36719C17.9246 4.74062 14.1453 1.01758 9.49414 1.01758C4.84297 1.01758 1.06367 4.74062 0.972266 9.36719C0.972266 9.30742 0.96875 9.25117 0.96875 9.19141C0.96875 4.48398 4.78672 0.666016 9.49414 0.666016C14.2016 0.666016 18.0195 4.48398 18.0195 9.19141Z",
    fill: "white",
    fillOpacity: 0.313726
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4238 9.56055C16.4238 13.2484 13.432 16.2402 9.74414 16.2402C7.67344 16.2402 5.8207 15.2945 4.59375 13.8145C5.81367 15.1328 7.55742 15.959 9.49805 15.959C13.1859 15.959 16.1777 12.9672 16.1777 9.2793C16.1777 7.66211 15.6047 6.18203 14.6484 5.02539C15.7488 6.21719 16.4238 7.80977 16.4238 9.56055Z",
    fill: "white",
    fillOpacity: 0.313726
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.9629C13.1891 15.9629 16.1797 12.9723 16.1797 9.2832C16.1797 5.59411 13.1891 2.60352 9.5 2.60352C5.81091 2.60352 2.82031 5.59411 2.82031 9.2832C2.82031 12.9723 5.81091 15.9629 9.5 15.9629Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 4.92383C13.3918 3.91484 11.8695 3.30664 10.2031 3.30664C6.51523 3.30664 3.52344 6.29844 3.52344 9.98633C3.52344 11.6527 4.13164 13.175 5.14062 14.3457C3.72031 13.1187 2.82031 11.3082 2.82031 9.2832C2.82031 5.59531 5.81211 2.60352 9.5 2.60352C11.5215 2.60352 13.3355 3.50352 14.5625 4.92383Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0566 5.59141C10.7324 7.11016 7.25898 10.4465 5.55742 14.6828C5.40977 14.5738 5.26562 14.4613 5.125 14.3383C4.11602 13.1676 3.50781 11.6453 3.50781 9.98242C3.50781 6.29453 6.49961 3.30273 10.1875 3.30273C11.8539 3.30273 13.3762 3.91094 14.5434 4.91992C14.7297 5.13438 14.8984 5.35938 15.0566 5.59141Z",
    fill: "white",
    fillOpacity: 0.145098
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.673828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.ef4416d564715e9c643eff9de29e6383.svg";
export { ForwardRef as ReactComponent };